<template>
  <div class="franchise">
    <page-header title="Франшиза" />
    <div id="links" class="public-container">
      <franchise-main />
      <public-service-links-grid
        :title="data.title"
        :items="items"
        class="mt-110 public-container-mobile"
      />
    </div>
    <franchise-geo />
    <div id="franchise-offer-block" class="public-container pt-5">
      <franchise-offer />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~~/components/public/page-header.vue'
import FranchiseMain from '~~/components/public/franchise/franchise-main.vue'
import FranchiseGeo from '~~/components/public/franchise/franchise-geo.vue'
import FranchiseOffer from '~~/components/public/franchise/franchise-offer.vue'
import PublicServiceLinksGrid from '~~/components/public/public-service-links-grid.vue'
import {getPageContent} from '~/api/content';

const data = (await getPageContent('/franchise')).blocks?.links

const items = computed(() => [
  {
    link: {
      to: { name: 'delivery-russia' },
    },
    icon: {
      url: '/svg/car/truck.svg'
    },
    title: data.deliveryTitle,
    text: data.deliveryText,
  },
  {
    link: {
      to: { name: 'networkshops' },
    },
    icon: {
      url: '/svg/cart.svg'
    },
    title: data.networkshopTitle,
    text: data.networkshopText,
  },
  {
    link: {
      to: {name: 'cargo-loading'},
    },
    icon: {
      url: '/svg/box-transportation.svg'
    },
    title: data.prrTitle,
    text: data.prrText,
  },
  {
    link: {
      to: {name: 'return-sd'},
    },
    icon: {
      url: '/svg/doc.svg'
    },
    title: data.returnSDTitle,
    text: data.returnSDText,
  },
  {
    link: {
      to: {name: 'safe-custody'},
    },
    icon: {
      url: '/svg/lock.svg'
    },
    title: data.storageTitle,
    text: data.storageText,
  },
  {
    link: {
      to: { name: 'wrapping' },
    },
    icon: {
      url: '/svg/package.svg'
    },
    title: data.wrappingTitle,
    text: data.wrappingText,
  },
  {
    link: {
      to: { name: 'insurance' },
    },
    icon: {
      name: 'shield'
    },
    title: data.insuranceTitle,
    text: data.insuranceText,
  },
  {
    link: {
      to: { name: 'address-delivery' },
    },
    icon: {
      name: 'map-marker'
    },
    title: data.addressDeliveryTitle,
    text: data.addressDeliveryText,
  }
])
</script>
